import { Errors } from '../enums/errors';
export class EMEError extends Error {
    constructor(code = Errors.EME_ERROR_UNKNOWN, message) {
        super(message);
        /**
         * Error status for network related eme errors.
         */
        this.status = -1;
        /**
         * The license server that was in use when the eror was thrown.
         */
        this.licenseServer = '';
        /**
         * True if the error should cause an endpoint refresh.
         */
        this.shouldRefreshEndpoint = false;
        /**
         * True if we cannot recover from this error.
         */
        this.unrecoverable = false;
        /**
         * Object for storing properties of an event that's usefull for debugging.
         */
        this.debug = {};
        this.code = code;
        this.message = message;
        this.name = 'EMEError';
    }
    static fatal(code = Errors.EME_ERROR_UNKNOWN, message) {
        const error = new EMEError(code, message);
        error.unrecoverable = true;
        return error;
    }
}
//# sourceMappingURL=eme.js.map